import { getResData, httpClient } from "utils";

import { UTILITY_BILLS_API_PATHS } from "./consts";
import { BillFileAttachment, BillSupportingDocument } from "./types";

export const getBillSupportingDocuments = (guid: string): Promise<BillSupportingDocument[]> =>
  httpClient
    .get<BillSupportingDocument[]>(UTILITY_BILLS_API_PATHS.BILL_SUPPORTING_DOCUMENTS_BY_GUID(guid))
    .then(getResData);

export const uploadBillSupportingDocuments = (
  billFiles: BillFileAttachment[],
  files: File[],
): Promise<BillSupportingDocument[]> => {
  const formData = new FormData();
  formData.append(
    "billFiles",
    new Blob([JSON.stringify(billFiles)], { type: "application/json" }),
  );
  files.forEach((file) => formData.append("files", file));
  return httpClient
    .post<BillSupportingDocument[]>(UTILITY_BILLS_API_PATHS.BILL_SUPPORTING_DOCUMENTS, formData)
    .then(getResData);
};

export const deleteBillSupportingDocument = (id: number): Promise<void> =>
  httpClient.delete(UTILITY_BILLS_API_PATHS.BILL_SUPPORTING_DOCUMENT(id));
